module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Unknown Battles That Lie Beyond the Grave")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-settling-among-the-natives-under-a-veil"
    }
  }, [_vm._v("Chapter 1: Settling\n          Among the Natives Under a Veil")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-when-misfortune-comes-knocking"
    }
  }, [_vm._v("Chapter 2: When Misfortune\n          Comes Knocking")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-missing-the-forest-for-the-trees-sexy-stories"
    }
  }, [_vm._v("Chapter 3:\n          Missing the Forest For the Trees: Sexy Stories")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-4-children-and-the-supernatural"
    }
  }, [_vm._v("Chapter 4: Children and the\n          Supernatural")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-5-the-impact-of-parental-issues-on-children"
    }
  }, [_vm._v("Chapter 5: The\n          Impact of Parental Issues on Children")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-6-guilt-and-grief"
    }
  }, [_vm._v("Chapter 6: Guilt and Grief")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-7-the-power-of-confrontation"
    }
  }, [_vm._v("Chapter 7: The Power of\n          Confrontation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-the-silver-lining",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Silver Lining")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-new-level-new-devils-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: New Level, New Devils\n          1")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-new-level-new-devils-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: New Level, New Devils\n          2")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-the-tiny-steps-that-lead-to-death",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Tiny\n          Steps that Lead to Death")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-a-place-where-nothing-is-hidden",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: A Place Where\n          Nothing Is Hidden")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-the-gliding-blood-sucker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Gliding Blood\n          Sucker")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-trial-by-the-jury-of-consuming-fire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Trial by\n          the Jury of Consuming Fire")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-self-defence-in-the-unknown-court",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Self-Defence\n          in the Unknown Court")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-the-intervention",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: The Intervention")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-seeing-things-hidden-from-mortals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Seeing\n          Things Hidden from Mortals")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-combat-ghosts-from-the-dead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Combat Ghosts from\n          the Dead")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-choosing-the-acts-assignments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Choosing the\n          Acts (Assignments)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-assembling-team-combat-ghost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Assembling Team\n          Combat Ghost")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21-the-stubborn-king-and-his-kingdom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: The Stubborn\n          King and His Kingdom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-22-the-natural-disaster-weapons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: The Natural\n          Disaster Weapons")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-23-the-wings-warehouse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Wings Warehouse")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-24-the-warriors-creed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: The Warrior’s Creed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-25-meeting-the-combat-ghosts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Meeting the Combat\n          Ghosts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-26-military-strategies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Military Strategies")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-27-the-war-speech-and-military-training",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: The War\n          Speech and Military Training")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-28-good-angels-bad-angels",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Good Angels, Bad\n          Angels")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-29-the-silence-of-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: The Silence of God")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-30-inside-the-invisible-door",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Inside the Invisible\n          Door")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-31-incursion-into-the-revolutionary-kingdom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31:\n          Incursion into the Revolutionary Kingdom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-32-heroic-episodes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Heroic Episodes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-33-fighting-in-retreat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Fighting in Retreat")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-34-the-point-of-no-return",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: The Point of No\n          Return")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-35-the-first-natural-disaster-weapon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: The First\n          Natural Disaster Weapon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-36-first-theres-calm-then-disaster-strikes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: First\n          There’s Calm, Then Disaster Strikes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-37-from-best-friends-to-worst-enemies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: From Best\n          Friends to Worst Enemies")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-38-the-second-natural-disaster-weapon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: The Second\n          Natural Disaster Weapon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-39-the-third-natural-disaster-weapon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: The Third\n          Natural Disaster Weapon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#chapter-40-asking-for-help",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: Asking for Help")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0